import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ModalProps } from "types/utils/modal";
import { pluralize } from "utils/pluralize";

export const ConfirmMoveToRecycleBin = ({
  isOpen,
  close,
  isLoading,
  confirm,
  selectedCount = 1,
}: ModalProps & {
  isLoading: boolean;
  confirm: () => void;
  selectedCount: number;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Move to recycle bin?">
          <div className="t-text-body-sm t-text-text-30">
            Are you sure you want to move{" "}
            {pluralize(selectedCount, "file", "files")} to the recycle bin? You
            can restore later if needed.
          </div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="primary"
            onClick={confirm}
          >
            Yes, move
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
